<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">Choisissez le coté concerné</div>

    <small
      v-if="
        intervention.typeOfProblem.$invalid && intervention.typeOfProblem.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner un coté
    </small>
    <div class="p-grid">
      <div class="interventionSelectorItem p-col-12 p-md-5 p-md-offset-1">
        <Card class="card-side" @click="selectTypeOfProblem(1)">
          <template #title>Gauche</template>
          <template #content>
            <div class="p-grid">
              <div class="p-col-4">
                <Image
                  id="card-image"
                  :src="useImage('vitre-conducteur.png')"
                  alt="Pare-brise"
                />
              </div>
              <div class="p-col">
                <div class="flex-elements">
                  <RadioButton
                    class="custom-radiobutton"
                    id="left"
                    name="typeOfProblem"
                    value="1"
                    v-model="typeOfProblem"
                  />
                  <p class="card-side-text">&nbsp;Côté conducteur</p>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </div>

      <div class="interventionSelectorItem p-col-12 p-md-5 p-md-offset-1">
        <Card class="card-side" @click="selectTypeOfProblem(2)">
          <template #title>Droit</template>
          <template #content>
            <div class="p-grid">
              <div class="p-col-6 p-offset-1">
                <div class="flex-elements">
                  <RadioButton
                    class="custom-radiobutton"
                    id="right"
                    name="typeOfProblem"
                    value="2"
                    v-model="typeOfProblem"
                  />
                  <p class="card-side-text">&nbsp;Côté passager</p>
                </div>
              </div>
              <div class="p-col-4 p-offset-1" style="text-align: right">
                <Image
                  id="card-image"
                  :src="useImage('vitre-passager.png')"
                  alt="Pare-brise"
                />
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>

    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepSides",

  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfProblem = ref(null);

    const rules = {
      typeOfProblem: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfProblem,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (typeOfProblem.value) {
        case "1":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.intervention_side = "left";
          break;
        case "2":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.intervention_side = "right";
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/cote-concerne',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.intervention_side) dataLayerToPush.intervention_side = appointmentStore.appointment.intervention_side;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };
    const onPrevious = () => {
      appointmentStore.appointment.intervention_side = null;
      emit("prevPage", menuStore.currentMenuItem);
    };

    const useImage = (imageName) => {
      return require(`../assets/img/${imageName}`);
    };

    const selectTypeOfProblem = (typeOfProblemId) => {
      typeOfProblem.value = `${typeOfProblemId}`
    };

    return {
      onNext,
      intervention,
      typeOfProblem,
      onPrevious,
      useImage,
      selectTypeOfProblem,
    };
  },
};
</script>

<style scoped>
::v-deep(.p-radiobutton .p-radiobutton-box.p-highlight){
    background: white !important;
}
::v-deep(.p-radiobutton-box.p-highlight .p-radiobutton-icon){
  background: var(--main) !important;
}
</style>

<style scoped>
::v-deep(.p-radiobutton .p-radiobutton-box.p-highlight){
    background: white !important;
}
::v-deep(.p-radiobutton-box.p-highlight .p-radiobutton-icon){
  background: black !important;
}
</style>

<style>
.interventionSelectorItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.card-side {
  background-color: #24a285;
  color: white !important;
  border-radius: 10px;
}
.card-side .p-card-content {
  color: white !important;
  padding: 0px !important;
}
.card-side .p-card-title {
  text-align: center;
  font-size: 1.5em !important;
}
.card-side .p-card-body {
  padding: 20px 0px 0px 0px !important;
}
.p-col {
  padding-bottom: 0px !important;
}
.p-col-4 {
  padding-bottom: 0px !important;
}
.flex-elements {
  display: flex;
  padding-top: 60px;
}
.card-side-text {
  font-size: 1.2em;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
  .card-side {
    margin-top: 10px;
  }

  .card-side .p-card-body {
    padding: 7px 0px 0px 0px !important;
  }

  .card-side .p-card-title {
    margin-bottom: 0px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .card-side {
    width: 280px !important;
  }
  .card-side-text {
    font-size: 1em !important;
  }
}
</style>
